import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { data: Array }

  connect() {
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not loaded")
      return
    }
    
    this.initializeChart()
  }
  
  initializeChart() {
    const ctx = this.element.querySelector('canvas').getContext('2d')
    
    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.dataValue.map(item => item.month),
        datasets: [{
          label: 'Facturas por Mes',
          data: this.dataValue.map(item => item.count),
          backgroundColor: 'rgba(69, 123, 157, 0.2)',
          borderColor: 'rgba(69, 123, 157, 1)',
          borderWidth: 2,
          tension: 0.1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          }
        }
      }
    })
    
    // Store the chart instance on the canvas element
    this.element.querySelector('canvas').__chart = chart
  }
}
